import { Component, DestroyRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { MarkantDatepicker } from '@markant/elements-angular';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DateValidators } from '@markant-platform/shared/form';

@Component({
  selector: 'markant-platform-filter-date',
  templateUrl: './filter-date.component.html',
  styleUrls: ['./filter-date.component.scss'],
})
export class FilterDateComponent implements OnInit {
  @Input() idStart = '';
  @Input() idEnd = '';
  @Input() label = '';
  @Input() resetNotifier$ = new Subject<void>();
  @Input() resetStartNotifier$ = new Subject<void>();
  @Input() resetEndNotifier$ = new Subject<void>();

  @Output() validEmitter = new EventEmitter<boolean>();
  @Output() filterChangeEmitter = new EventEmitter<Record<string, string[]>>();

  @ViewChild('start') startDate!: MarkantDatepicker;
  @ViewChild('end') endDate!: MarkantDatepicker;

  dateForm!: FormGroup;
  private readonly dateFormat = 'dd.MM.yyyy';

  constructor(
    private readonly datePipe: DatePipe,
    private readonly destroyRef: DestroyRef
  ) {}

  ngOnInit(): void {
    this.resetNotifier$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(_ => {
      this.filterChangeEmitter.emit({
        [this.idStart]: [],
        [this.idEnd]: [],
      });
      this.startDate.value = '';
      this.endDate.value = '';
      this.dateForm.setErrors(null);
      this.validEmitter.emit(true);
    });

    this.resetEndNotifier$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(_ => {
      this.filterChangeEmitter.emit({
        [this.idEnd]: [],
      });
      this.endDate.value = '';
      this.dateForm.setErrors(null);

      this.dateForm = this.initializeFormGroup();
    });

    this.resetStartNotifier$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(_ => {
      this.filterChangeEmitter.emit({
        [this.idStart]: [],
      });
      this.startDate.value = '';
      this.dateForm.setErrors(null);

      this.dateForm = this.initializeFormGroup();
    });

    this.dateForm = this.initializeFormGroup();

    this.validEmitter.emit(true);
    this.dateForm.statusChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(value => {
      this.validEmitter.emit(value === 'VALID');
    });
  }

  selectDate(event: any, value: string): void {
    if (event.detail === '') {
      this.filterChangeEmitter.emit({ [value]: [''] });
      return;
    }

    const isoDateString = this.parseDate(event.detail, event.target.id).toISOString();
    this.filterChangeEmitter.emit({ [value]: [isoDateString] });
  }

  private initializeFormGroup(): FormGroup {
    return new FormGroup(
      {
        startDate: new FormControl(this.datePipe.transform(this.startDate?.value, this.dateFormat, 'UTC'), [
          Validators.required,
        ]),
        endDate: new FormControl(this.datePipe.transform(this.endDate?.value, this.dateFormat, 'UTC'), [
          Validators.required,
        ]),
      },
      { validators: DateValidators.interval() }
    );
  }

  //Converts Date to UTC format disregarding current timezone
  private parseDate(raw: string, element?: string): Date {
    const [day, month, year] = raw.split('.');

    if (element && element === 'end') {
      return new Date(Date.UTC(+year, +month - 1, +day, 23, 59, 59, 999));
    }

    return new Date(Date.UTC(+year, +month - 1, +day));
  }
}
